/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DocumentDtoListApiResponse } from '../../models/document-dto-list-api-response';

export interface UploadCustomerDocumentAsync$Plain$Params {
  id: number;
      body?: {
'files'?: Array<Blob>;
}
}

export function uploadCustomerDocumentAsync$Plain(http: HttpClient, rootUrl: string, params: UploadCustomerDocumentAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentDtoListApiResponse>> {
  const rb = new RequestBuilder(rootUrl, uploadCustomerDocumentAsync$Plain.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DocumentDtoListApiResponse>;
    })
  );
}

uploadCustomerDocumentAsync$Plain.PATH = '/api/customer/{id}/document';
